import { useTranslate } from "@similarweb/i18n-provider";

import { FormFieldLabel } from "app/pages/sales-intelligence/common-components/form-fields";
import RangeSelectWithClear from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/filters/RangeSelectFilter/RangeSelectWithClear";
import type { IRange } from "app/pages/sales-intelligence/types/range";

import leadsSearchFiltersI18nKeys from "../../utils/i18n";

interface IRangeSelectWithClearFieldProps<T> {
    field: keyof T;
    buckets: readonly number[];
    formatter: (value: number | string) => string;
    value?: Partial<IRange<number>>;
    placeholderPrefix?: string;
    isDisabled?: boolean;
    onHandleChange: (field: keyof T, range: IRange<number>) => void;
    onHandleClear: (field: keyof T) => VoidFunction;
}

export const RangeSelectWithClearField = <T,>({
    field,
    buckets,
    formatter,
    value,
    onHandleChange,
    onHandleClear,
    placeholderPrefix,
    isDisabled = false,
}: IRangeSelectWithClearFieldProps<T>) => {
    const { translate } = useTranslate();

    return (
        <FormFieldLabel text={translate(leadsSearchFiltersI18nKeys.filter(String(field)))}>
            <RangeSelectWithClear
                fieldName={String(field)}
                value={value}
                onClear={onHandleClear(field)}
                buckets={buckets}
                formatValue={formatter}
                placeholderPrefix={placeholderPrefix}
                isDisabled={isDisabled}
                onChange={([from, to]) => onHandleChange(field, { from, to })}
            />
        </FormFieldLabel>
    );
};
